import React, { useCallback, useEffect, useRef, useState } from "react";
import { FiGlobe, FiSearch } from "react-icons/fi";
import { useLanguage } from "../../i18n";
import "./MapSearchBar.css";

export default function MapSearchBar({
  onPress,
  onCountryPress,
  browseCountry = "",
  collapseProgress = 0,
}) {
  const { t } = useLanguage();
  const [globePulse, setGlobePulse] = useState(false);
  const pulseTimer = useRef(null);

  useEffect(() => () => {
    if (pulseTimer.current) clearTimeout(pulseTimer.current);
  }, []);

  const handleGlobePress = useCallback(() => {
    setGlobePulse(true);
    if (pulseTimer.current) clearTimeout(pulseTimer.current);
    pulseTimer.current = setTimeout(() => setGlobePulse(false), 560);
    onCountryPress?.();
  }, [onCountryPress]);

  const globeLabel = browseCountry
    ? t("home.selectCountryWithName", { country: browseCountry })
    : t("home.selectCountry");

  return (
    <div
      className={[
        "map-search-bar",
        collapseProgress > 0.02 ? "map-search-bar--collapsing" : "",
        collapseProgress > 0.85 ? "map-search-bar--compact" : "",
      ].filter(Boolean).join(" ")}
      style={{ "--collapse": collapseProgress }}
    >
      <button type="button" className="map-search-bar__icon-btn" onClick={onPress} aria-label={t("home.searchPlaceholder")}>
        <FiSearch />
      </button>
      <button type="button" className="map-search-bar__text" onClick={onPress}>
        {t("home.searchPlaceholder")}
      </button>
      {onCountryPress ? (
        <button
          type="button"
          className={`map-search-bar__icon-btn map-search-bar__globe${globePulse ? " map-search-bar__globe--pulse" : ""}`}
          onClick={handleGlobePress}
          aria-label={globeLabel}
        >
          <span className="map-search-bar__globe-ripple" aria-hidden />
          <FiGlobe aria-hidden />
        </button>
      ) : null}
    </div>
  );
}
